import cn from 'classnames';
import { useState } from 'react';
import { trackError } from '#api/errors.ts';
import { CopyIcon } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { CodeBlock } from '#components/atoms/code/CodeBlock.tsx';
import { useTimeout } from '#hooks/useTimeout.ts';
import { copyToClipboard } from '#util/copy-to-clipboard.ts';
import { DOWNLOADS_URL } from './downloads.ts';
import styles from './DownloadLinkSnippet.module.css';

const COPY_LABEL = 'Copy link';

/** The DNClient Desktop download URL with a primary copy button, since sharing it is how people get enrolled. */
export function DownloadLinkSnippet({ className }: { className?: string }) {
  const [label, setLabel] = useState(COPY_LABEL);
  const { start: resetLabelAfterDelay } = useTimeout(() => {
    setLabel(COPY_LABEL);
  }, 2000);

  return (
    <CodeBlock className={cn(styles.DownloadLinkSnippet, className)} breakWord={true}>
      <code className="mw-0">{DOWNLOADS_URL}</code>
      <Button
        size="xsmall"
        className={styles.DownloadLinkSnippet_button}
        onClick={() => {
          copyToClipboard(DOWNLOADS_URL)
            .then(() => {
              setLabel('Copied!');
              return resetLabelAfterDelay();
            })
            .catch((err: unknown) => {
              setLabel('Unable to copy');
              trackError(err);
              resetLabelAfterDelay();
            });
        }}
      >
        <CopyIcon aria-hidden="true" />
        <span aria-live="polite">{label}</span>
      </Button>
    </CodeBlock>
  );
}
